/**
 * Handles adding a gift card product to the cart from the cart page / drawer.
 * Called via onclick="window.addGiftToCartFromCartPage(event, this)" in gift-card-block.liquid.
 *
 * Previously inlined in theme.liquid (not cacheable). Extracted to an asset
 * file so the browser can cache it across page loads.
 */
window.addGiftToCartFromCartPage = async function (event, button) {
  // 1. Stop all native theme interference
  event.preventDefault();
  event.stopPropagation();

  // 2. Gather the data
  const wrapper = button.closest('[data-gift-wrapper]');
  const toggle = wrapper.querySelector('.gift-card-toggle');
  const messageInput = wrapper.querySelector('[data-message-input]');

  // Validation: abort if the message textarea is empty
  if (messageInput && messageInput.value.trim() === '') {
    // Trigger the native browser validation popup
    messageInput.setCustomValidity('Please enter your gift message.');
    messageInput.reportValidity();

    // Auto-focus the cursor inside the box
    messageInput.focus();

    // Clear the error state as soon as they start typing
    messageInput.addEventListener('input', () => {
      messageInput.setCustomValidity('');
    }, { once: true });

    return; // Abort the add-to-cart process completely
  }

  const originalText = button.innerHTML;

  // 3. Accessibility & UI feedback
  button.setAttribute('disabled', 'disabled');
  button.style.pointerEvents = 'none'; // Prevent double-clicking
  button.innerHTML = 'Adding...';

  const giftVariantId = parseInt(toggle.getAttribute('data-variant-id'), 10);
  const mainProductTitle = toggle.getAttribute('data-main-product-title');
  const mainProductId = toggle.getAttribute('data-main-product-id');
  const isSingleMode = toggle.getAttribute('data-single-mode') === 'true';
  const giftMessage = messageInput.value.trim();

  // Build the line item properties based on single vs multi-product mode
  let properties = {
    'Gift Message': giftMessage,
    '_Timestamp': Date.now(), // Ghost-bug protection: ensures unique line items
  };

  if (!isSingleMode) {
    properties['_Associated Product'] = mainProductTitle;
    properties['_Associated_Product_ID'] = mainProductId;
  }

  const payload = {
    items: [{
      id: giftVariantId,
      quantity: 1,
      properties: properties,
    }],
  };

  try {
    // 4. Send the AJAX request
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      // Redirect with cache-buster to ensure updated cart renders
      window.location.replace(window.Shopify.routes.root + 'cart?sync=' + Date.now());
    } else {
      console.error('Failed to add gift card from cart page.');
      alert('Sorry, there was an issue adding the gift card.');
      button.removeAttribute('disabled');
      button.style.pointerEvents = 'auto';
      button.innerHTML = originalText;
    }
  } catch (error) {
    console.error('Network error:', error);
    button.removeAttribute('disabled');
    button.style.pointerEvents = 'auto';
    button.innerHTML = originalText;
  }
};
